import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

import { Breadcrumb } from './core/top-navbar/breadcrumb/breadcrumb.model';
import { RCSA_DIALOG_SERVICE_TOKEN } from './feature-shared/services/rcsa-dialog-service.token';
import { canActivateCurrentLibraryControl } from './library-control/guards/can-activate-current-library-control.guard';
import { overviewResolver } from './overview/route-resolver';
import { RcsaDialogService } from './rcsa/common/rcsa-dialog.service';
import { ROUTES } from './shared/constants/routes';
import { canDeactivateGuard } from './shared/guards/can-deactivate.guard';
import { TitleKey } from './shared/services/title.service';

export const appRoutes: Routes = [
  {
    path: ROUTES.rcsa,
    loadChildren: () => import('./rcsa/rcsa.routes').then(x => x.rcsaRoutes),
    data: { breadcrumb: { label: 'RCSAs', key: 'rcsa' } as Breadcrumb },
    canActivate: [MsalGuard],
  },
  {
    path: ROUTES.wizard.root,
    loadChildren: () => import('./wizard/routes').then(x => x.wizardRoutes),
  },
  {
    path: ROUTES.home,
    loadChildren: () => import('./home/home.routes').then(x => x.homeRoutes),
    data: { breadcrumb: { label: 'Home', key: 'home' } as Breadcrumb },
    canActivate: [MsalGuard],
  },
  {
    path: `${ROUTES.standardDetail}`,
    providers: [{ provide: RCSA_DIALOG_SERVICE_TOKEN, useClass: RcsaDialogService }],
    children: [
      {
        path: '',
        loadComponent: () => import('./standards/standard-detail.component').then(x => x.StandardDetailComponent),
        canDeactivate: [canDeactivateGuard],
        data: {
          breadcrumb: { label: 'Standard detail', key: 'standardDetail' } as Breadcrumb,
          titleKey: 'newStandardDetail' as TitleKey,
        },
      },
      {
        path: ':id',
        loadComponent: () => import('./standards/standard-detail.component').then(x => x.StandardDetailComponent),
        canDeactivate: [canDeactivateGuard],
        data: {
          breadcrumb: { label: 'Standard detail', key: 'standardDetail' } as Breadcrumb,
          titleKey: 'existingStandardDetail' as TitleKey,
        },
      },
    ],
    data: { breadcrumb: { label: 'Standards', key: 'standards' } as Breadcrumb },
    canActivate: [MsalGuard],
  },
  {
    path: `${ROUTES.overview}`,
    children: [
      {
        path: ':riskCaseType/:id',
        loadComponent: () => import('./overview/overview.component').then(x => x.OverviewComponent),
        data: {
          breadcrumb: {
            label: 'Risk Case Summary',
            key: 'overview',
            shouldPreservePrevious: true,
          } as Breadcrumb,
          titleKey: 'overview' as TitleKey,
        },
        resolve: {
          steps: overviewResolver,
        },
      },
    ],
    canActivate: [MsalGuard],
  },
  {
    path: `${ROUTES.libraryControl}`,
    children: [
      {
        path: '',
        canDeactivate: [canDeactivateGuard],
        loadComponent: () => import('./library-control/library-control.component').then(x => x.LibraryControlDetailComponent),
        data: {
          breadcrumb: {
            label: 'Library Control',
            key: 'libraryControlDetail',
            shouldPreservePrevious: true,
          } as Breadcrumb,
          titleKey: 'homeLibraryControls' as TitleKey,
        },
      },
      {
        path: ':id',
        canActivate: [canActivateCurrentLibraryControl()],
        canDeactivate: [canDeactivateGuard],
        loadComponent: () => import('./library-control/library-control.component').then(x => x.LibraryControlDetailComponent),
        data: {
          breadcrumb: {
            label: 'Library Control',
            key: 'libraryControlDetail',
            shouldPreservePrevious: true,
          } as Breadcrumb,
          titleKey: 'homeLibraryControls' as TitleKey,
        },
      },
    ],
    canActivate: [MsalGuard],
  },
  {
    path: ROUTES.error,
    loadComponent: () => import('./core/error-page/error-page.component').then(m => m.ErrorPageComponent),
  },
];
